<template>
  <div id="TopUp">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">
          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <!-- <alert-card></alert-card> -->
          <h2>สมุดบัญชี</h2>
          <template v-if="userData.userType === 'A'">
            <b-row>
              <b-col sm="6"></b-col>
              <b-col sm="6">
                <b-card body-class="p-0">
                  <b-card-body>
                    <b-form @submit="onSubmit">
                      <b-card-text>
                        <label for="form_userCode" class="mb-1">รหัสสมาชิก:</label>
                        <b-input-group class="mb-2">
                            <b-form-input id="form_userCode" v-model="form.userCode" type="text" autocomplete="off"></b-form-input>
                          <b-input-group-append>
                            <!-- @click="getDataTracking" -->
                            <b-button variant="success" type="submit">ค้นหา</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-card-text>
                    </b-form>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
            <hr />
          </template>
          <b-overlay
            id="overlay-dataRevenueReady"
            :show="!dataRevenueReady"
            variant="light"
            :opacity="0.95"
            blur="4px"
            rounded="sm"
          >
            <template #overlay>
              <div class="text-center">
                <h4 id="cancel-label">กำลังเรียกดูข้อมูล</h4>
              </div>
            </template>

            <b-table striped bordered small responsive
              :items="RevenueItems" :fields="RevenueFields"
              show-empty empty-text="ไม่พบการชำระเงิน"
              class="table-mini">

              <template #cell(revenueID)="data">
                {{ "HRA-" + data.value}}
              </template>

              <template #cell(dateRevenue)="data">
                <small>{{ data.item.createRevenuetime.date + ' ' + data.item.createRevenuetime.time }}</small>
              </template>

              <template #cell(detail)="data">
                <b v-if="userData.userType === 'A'">[{{ data.item.userCode }}] </b>{{data.item.revenueDetail}}
              </template>

              <template #cell(revenueAccount)="data">
                <b :class="data.item.revenueType === '+' ? 'text-success' : data.item.revenueType === '-' ? 'text-danger' : 'text-muted'">
                  {{ data.item.revenueType + parseFloat(data.item.revenueBalance).toFixed(2) }}
                </b>
              </template>

              <template #cell(cashBalance)="data">
                <b>{{ parseFloat(data.value).toFixed(2) }}</b>
              </template>

            </b-table>
          </b-overlay>

        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Revenue",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataRevenue()
  },
  data() {
    return {
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        userName: "",
        userCode: "",
      },
      dataReady: false,
      dataRevenueReady: false,
      RevenueFields: [
        { key: 'revenueID', label: 'หมายเลขรายการ' },
        // { key: 'userCode', label: 'รหัสสมาชิก' },
        { key: 'dateRevenue', label: 'วันที่ทำรายการ', class: 'text-center' },
        { key: 'detail', label: 'รายละเอียด' },
        { key: 'revenueAccount', label: 'จำนวนเงิน', class: 'text-right' },
        { key: 'cashBalance', label: 'คงเหลือ', class: 'text-right'  },
      ],
      RevenueItems: [],
    };
  },
  methods: {
    getDateNow () {
      let dateTime = this.getNowGlobal().split(' ')
      this.form.transferDate = dateTime[0]
      this.form.transferTime = dateTime[1]
    },
    formatDate (strDate) {
      if (strDate) {
        var dtDate = strDate.split(' ')[0]
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0]
        return strDateShort
      } else {
        return ''
      }
    },
    getDataUser() {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser

        this.form.CREATE_USER = this.userData.userName
        this.form.userName = this.userData.userName
        this.form.userCode = this.userData.userCode

        this.dataReady = true
      } else {
        this.$router.push('/Login')
      }
    },
    getDataRevenue () {
      this.dataRevenueReady = false
      this.RevenueItems = []
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Revenue/Revenue_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType,
          {
            headers: this.getHeaderAPI('Revenue_list', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataTopUp', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let RevenueData = rs.data[i]

                RevenueData.createRevenuetime = this.formatDateTime(rs.data[i].CREATE_DATE)
                // RevenueData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)

                this.RevenueItems.push(RevenueData)
              }

              console.log('getDataTopUp', this.RevenueItems)
            }
          }

          this.dataRevenueReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTopUp error:', error)
          this.dataRevenueReady = true
          this.RevenueItems = []
        });
    },
    onSubmit(event) {
      event.preventDefault()
      this.dataRevenueReady = false
      this.RevenueItems = []
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Revenue/Revenue_list?userName=' +
          this.userData.userName +
          '&userCode=' +
          this.form.userCode +
          '&userType=' +
          this.userData.userType,
          {
            headers: this.getHeaderAPI('Revenue_list', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataTopUp', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let RevenueData = rs.data[i]

                RevenueData.createRevenuetime = this.formatDateTime(rs.data[i].CREATE_DATE)
                // RevenueData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)

                this.RevenueItems.push(RevenueData)
              }

              console.log('getDataTopUp', this.RevenueItems)
            }
          }

          this.dataRevenueReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTopUp error:', error)
          this.dataRevenueReady = true
          this.RevenueItems = []
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

.py-75{
  padding-top: .75rem !important;
  padding-bottom: .75rem !important;
}

.ex-card{
  border-style: dotted;
  border-width: 2px;
}

.ex-card > .card-body {
  padding: .75rem;
}

.dropdown-menu {
  min-width: 5rem !important;
  /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/components/User/Revenue.vue